<template>
    <div v-cloak v-if="show" class="bg-white pb-3 sm:pt-3">
        <div class="container px-0 sm:px-4">
            <div class="relative py-6 sm:py-4 sm:rounded" class2="bg-gray-200" style="background-color: #e8e8ea;">
                <button @click="close" type="button" class="absolute top-0 right-0 z-10 mt-4 mr-4 text-gray-600 hover:text-gray-700 py-1 px-2 focus:outline-none" title="Hide">
                    <i class="far fa-times fa-lg"></i>
                </button>

                <div class="flex justify-center">
                    <div v-if="!mobile" class="w-full sm:w-1/2 text-center">
                        <img data-src="/img/productwall.png" width="400" height="388" alt="" class="lazyload img-fluid inline" />
                    </div>

                    <div class="w-full sm:w-1/2">
                        <div class="px-4 sm:px-0">
                            <h1 class="mt-0 sm:mt-2 text-3xl sm:text-4xl font-semibold text-left sm:text-center">
                                <i class="far fa-search-location text-gray-800 mr-2"></i>
                                Product Tracker
                            </h1>

                            <h2 class="mt-6 text-2xl font-thin text-center">
                                Real-time in stock alerts to help find what you want
                            </h2>

                            <p class="leading-snug mt-4 sm:mt-6 text-base sm:text-lg font-normal text-center sm:text-left">
                                NamePromo tracks the products you are interested in and sends you in-stock alerts 🔔 via email, text message (SMS), or mobile push notifications immediately when sold out products you follow are back in stock.
                            </p>

                            <div class="flex justify-center mt-6 text-center">
                                <div class="w-8/12 lg:w-6/12">
                                    <a href="/register" class="btn btn-success btn-lg btn-block rounded-full font-semibold sm:text-xl lg:text-2xl">
                                        <i class="fad fa-chevron-circle-right mr-2"></i>
                                        Signup Free
                                    </a>
                                </div>

                                <!-- <div class="mt-5 w-8/12 lg:w-6/12">
                                    <a href="/app/ios">
                                        <img src="/img/appstore.png" />
                                    </a>

                                    <a href="/app/android">
                                        <img src="/img/googleplay.png" />
                                    </a>
                                </div> -->

                                <!-- <div class="w-4/12">
                                    <a href="/learn-more" class="btn btn-secondary bg-light btn-lg btn-block rounded-full font-semibold">
                                        Learn More
                                    </a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        show: true,
        cookieName: 'promo_welcome'
    }),

    created() {
        if (this.user) {
            this.show = false;
        } else {
            const value = this.getCookie(this.cookieName);
            if (value === 'false' || value === false) {
                this.show = false;
            }
        }
    },

    mounted() {},

    methods: {
        close() {
            this.setCookie(this.cookieName, false, 365);

            this.show = false;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
